"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderLink = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const HeaderLink = props => {
  const {
    item,
    offNavigation,
    toggleMobileNav,
    t
  } = props;
  return item.headerType.toLowerCase() === "button-external" ? /*#__PURE__*/_react.default.createElement("a", {
    className: "con-text con-text__link",
    href: item.headerElement.url,
    key: t(item.headerElement.text)
  }, t(item.headerElement.text)) : item.headerType.toLowerCase() === "button-internal" ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    key: t(item.headerElement.text),
    className: "con-text con-text__link",
    to: item.headerElement.url,
    onClick: () => {
      offNavigation();
      toggleMobileNav();
    }
  }, t(item.headerElement.text)) : console.error("invalid headerType");
};
exports.HeaderLink = HeaderLink;
HeaderLink.propTypes = {
  t: _propTypes.default.func,
  item: _propTypes.default.object,
  offNavigation: _propTypes.default.func,
  toggleMobileNav: _propTypes.default.func
};